import { render, staticRenderFns } from "./LayoutBackground.vue?vue&type=template&id=5e86cfe9"
import script from "./LayoutBackground.vue?vue&type=script&lang=js"
export * from "./LayoutBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports